import { render } from "./TreePanel.vue?vue&type=template&id=59d4a564&scoped=true"
import script from "./TreePanel.vue?vue&type=script&lang=ts"
export * from "./TreePanel.vue?vue&type=script&lang=ts"

import "./TreePanel.vue?vue&type=style&index=0&id=59d4a564&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-59d4a564"

export default script